module.exports = __webpack_public_path__ + "img/Pop-up_10.2d51cd57.png";